module.exports = __webpack_public_path__ + "img/marketing-plan.4483d846.png";